export const GET_VIDEO = "GET_VIDEO";
export const GET_VIDEO_DETAIL = "GET_VIDEO_DETAIL";
export const GET_COMMENT = "GET_COMMENT";
export const GET_LIKE = "GET_LIKE";
export const DELETE_VIDEO = "DELETE_VIDEO";
export const DELETE_COMMENT = "DELETE_COMMENT";;
